import React from 'react';
import { CtaButton } from '../ui/CtaButton';
import { scrollToBuy } from '../config';
import { CheckCircle2 } from 'lucide-react';
export function Hero() {
  return <section className="bg-brand-sand pt-8 pb-10 sm:pt-16 sm:pb-20 lg:pt-24 lg:pb-28 overflow-hidden" data-id="element-98">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-99">
        {/* Headline + intro */}
        <p className="text-brand-teal font-semibold tracking-wide uppercase text-xs sm:text-sm mb-2 sm:mb-4" data-id="element-100">
          Para nutricionistas que recién arrancan y los que saben que les falta
          estructura
        </p>

        <h1 className="text-2xl sm:text-5xl lg:text-6xl font-serif font-bold text-brand-charcoal leading-tight mb-3 sm:mb-6" data-id="element-101">
          Si sos nutricionista y todavía armás el plan de tu paciente la noche
          anterior a la consulta...
        </h1>

        <p className="text-base sm:text-xl text-gray-600 mb-5 sm:mb-12 font-medium" data-id="element-102">
          Esto es para vos.
        </p>

        {/* Product mockup image below the hero */}
        <div className="mb-5 sm:mb-12" data-id="element-103">
          <button onClick={scrollToBuy} aria-label="Ver la oferta de El Arsenal del Nutri" className="block w-full focus:outline-none focus:ring-2 focus:ring-brand-teal rounded-xl" data-id="element-104">
            <img src="https://cdn.magicpatterns.com/uploads/eoda9Y571jFVNsSp9S97bd/498cede4-f559-46a6-a912-168670575976-removebg-preview.png" alt="El Arsenal del Nutri — Mega Pack con 12 tomos clínicos y 6 bonos incluidos" className="w-full max-w-2xl mx-auto h-auto max-h-[32vh] sm:max-h-none object-contain transition-transform hover:scale-[1.02]" data-id="element-105" />
          </button>
        </div>

        {/* CTA box with information below the image */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 sm:p-8 text-left max-w-2xl mx-auto" data-id="element-106">
          <h2 className="text-lg sm:text-2xl font-bold text-brand-teal mb-3 sm:mb-4 text-center" data-id="element-107">
            EL ARSENAL DEL NUTRI — Sistema Operativo 360°
          </h2>

          <ul className="space-y-2 sm:space-y-3 mb-4 sm:mb-6" data-id="element-108">
            {['12 tomos clínicos + 6 bonos incluidos.', 'Sobrepeso, diabetes, cardiovascular, intestinal, vegano, ciclo de vida y más.', 'Protocolos listos para usar desde mañana. Anamnesis, plan nutricional, seguimiento y criterios de alta.', 'Adaptado a la práctica argentina. Marcas de supermercado, honorarios con inflación, lenguaje clínico real.', 'Descargás. Imprimís. Llegás a cada consulta con un plan claro.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-109">
                <CheckCircle2 className="w-5 h-5 text-brand-accent flex-shrink-0 mt-0.5" data-id="element-110" />
                <span className="text-gray-700" data-id="element-111">{item}</span>
              </li>)}
          </ul>

          <div className="bg-brand-teal/5 rounded-lg p-5 border border-brand-teal/10 text-center" data-id="element-112">
            <p className="font-bold text-lg text-brand-charcoal mb-1" data-id="element-113">
              Pago único de $19.990 ARS
            </p>
            <p className="text-sm text-gray-600 mb-4" data-id="element-114">
              Acceso inmediato · Garantía de 7 días
            </p>
            <CtaButton fullWidth data-id="element-115">QUIERO EL ARSENAL AHORA</CtaButton>
          </div>
        </div>
      </div>
    </section>;
}